import * as DTO from './DTO/bank'
import * as Dictionaries from './dictionaries'
import * as Enums from './enums'

export { Dictionaries, DTO, Enums }

export * from './api'
export * from './webPages'
